import React from 'react';
import PropTypes from 'prop-types';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CloseIcon from '@material-ui/icons/Close';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';

const ICONS = {
  error: ErrorOutlineIcon,
  info: InfoOutlinedIcon,
  neutral: InfoOutlinedIcon,
  success: CheckCircleOutlineIcon,
  warning: WarningRoundedIcon,
};

const AlertDismissible = ({
  closeLabel,
  message,
  onClose,
  title,
  tone,
}) => {
  const Icon = ICONS[tone] || ICONS.info;
  const isAssertive = tone === 'error' || tone === 'warning';

  return (
    <section
      className={`kea-alert kea-alert--${tone}`}
      role={isAssertive ? 'alert' : 'status'}
      aria-live={isAssertive ? 'assertive' : 'polite'}
      data-testid="global-alert"
    >
      <span className="kea-alert__icon" aria-hidden="true">
        <Icon fontSize="small" />
      </span>
      <div className="kea-alert__content">
        {title && <h2 className="kea-alert__title">{title}</h2>}
        {message && <div className="kea-alert__message">{message}</div>}
      </div>
      <button
        type="button"
        className="kea-alert__close"
        onClick={onClose}
        aria-label={closeLabel}
      >
        <CloseIcon fontSize="small" />
      </button>
    </section>
  );
};

AlertDismissible.propTypes = {
  closeLabel: PropTypes.string.isRequired,
  message: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  tone: PropTypes.oneOf(['error', 'info', 'neutral', 'success', 'warning']),
};

AlertDismissible.defaultProps = {
  message: null,
  title: null,
  tone: 'info',
};

export default AlertDismissible;
